import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './services/auth.interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { CommonModule } from '@angular/common';

import { AppComponent } from './app.component';
import { DashboardShellComponent } from './components/dashboard-shell/dashboard-shell.component';
import { CurrentCustomersComponent } from './components/views/current-customers/current-customers.component';
import { WorkOrdersProgressComponent } from './components/views/work-orders-progress/work-orders-progress.component';
import { KnittingOrderProgressComponent } from './components/views/knitting-order-progress/knitting-order-progress.component';
import { RejectedKnittingOrdersComponent } from './components/views/rejected-knitting-orders/rejected-knitting-orders.component';
import { ShiftAnnouncementComponent } from './components/views/shift-announcement/shift-announcement.component';
import { MachineProductionRateComponent } from './components/views/machine-production-rate/machine-production-rate.component';
import { ClosedKnittingOrdersComponent } from './components/views/closed-knitting-orders/closed-knitting-orders.component';
import { RejectedMachinesComponent } from './components/views/rejected-machines/rejected-machines.component';
import { DevViewSwitcherComponent } from './components/dev-view-switcher/dev-view-switcher.component';
import { BackgroundLinesComponent } from './components/common/background-lines/background-lines.component';
import { MotionAnimateDirective } from './directives/motion-animate.directive';
import { AnimateProgressBarDirective } from './directives/animate-progress-bar.directive';
import { PerformanceMetricsCardComponent } from './components/performance-metrics-card/performance-metrics-card.component';

@NgModule({
  declarations: [
    AppComponent,
    DashboardShellComponent,
    CurrentCustomersComponent,
    WorkOrdersProgressComponent,
    KnittingOrderProgressComponent,
    RejectedKnittingOrdersComponent,
    ShiftAnnouncementComponent,
    MachineProductionRateComponent,
    ClosedKnittingOrdersComponent,
    RejectedMachinesComponent,
    DevViewSwitcherComponent,
    BackgroundLinesComponent,
    MotionAnimateDirective,
    AnimateProgressBarDirective,
    PerformanceMetricsCardComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
  ],
  providers: [
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor])),
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
